export const chevronIcon = {
  data: `<svg>
          <title>chevron</title>
          <g
            id="Assets-/-Icon-/-Chevron"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
          >
            <g
              id="Dark"
              transform="translate(9.000000, 5.792893) rotate(45.000000) translate(-9.000000, -5.792893) translate(4.000000, 0.792893)"
              stroke="#424242"
            >
              <line
                x1="0.196699141"
                y1="9.3890873"
                x2="8.68198052"
                y2="9.3890873"
                id="Line-4"
              ></line>
              <line
                x1="4.43933983"
                y1="5.14644661"
                x2="12.9246212"
                y2="5.14644661"
                id="Line-4"
                opacity="0.99"
                transform="translate(8.681981, 5.146447) rotate(90.000000) translate(-8.681981, -5.146447) "
              ></line>
            </g>
          </g>
        </svg>`,
  name: 'chevron',
};
